import { dateTimeFormateTypes } from '@/constants/types';
import { format } from 'date-fns';

export const formatDate = (date, formate = dateTimeFormateTypes.default) => {
  if (!date) {
    return '';
  }

  try {
    const parsedDate = new Date(date);
    if (Number.isNaN(parsedDate.getTime())) {
      return '';
    }
  } catch (error) {
    return '';
  }

  return format(new Date(date), formate);
};

export const addDaysToCurrentDate = (daysToAdd) => {
  const days = parseInt(daysToAdd, 10) || 0;
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate;
};

export const getShippingMethodDate = (daysToAdd) => {
  const days = parseInt(daysToAdd, 10) || 0;
  const currentDate = new Date();
  const endDate = currentDate.setDate(currentDate.getDate() + days);
  const formattedEndDate = format(new Date(endDate), 'd MMMM yyyy');
  const formattedStartDate = format(new Date(), 'd MMMM yyyy');
  return `${formattedStartDate} - ${formattedEndDate}`;
};

export const getEstimatedPickupDateString = (
  startDate,
  shippingDuration = 0,
) => {
  if (shippingDuration < 0) {
    return '';
  }

  const targetDate = new Date(startDate);
  const endDate = targetDate.setDate(targetDate.getDate() + shippingDuration);
  const formattedEndDate = format(new Date(endDate), 'MMMM d, yyyy');
  const formattedStartDate = format(startDate, 'MMMM d, yyyy');
  return `${formattedStartDate} to ${formattedEndDate}`;
};

export const isSpinTheWheelEnded = ({ wheelDetails = null, list = [] }) => {
  if (
    !wheelDetails ||
    wheelDetails === undefined ||
    list === undefined ||
    (Array.isArray(list) && list?.length === 0)
  )
    return true;

  const currentDate = new Date();
  const endDate = new Date(wheelDetails?.end_date);

  return currentDate > endDate;
};

export const getDaysDifference = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return '0 days';

  const start = new Date(startDate);
  const end = new Date(endDate);

  const differenceInTime = end.getTime() - start.getTime();
  const differenceInMinutes = Math.ceil(differenceInTime / (1000 * 60));

  if (differenceInMinutes < 60) {
    return `${differenceInMinutes} minutes`;
  }

  const differenceInHours = Math.ceil(differenceInTime / (1000 * 3600));
  if (differenceInHours < 24) {
    return `${differenceInHours} hours`;
  }

  const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
  if (differenceInDays < 7) {
    return `${differenceInDays} days`;
  }

  const differenceInWeeks = Math.ceil(
    differenceInTime / (1000 * 3600 * 24 * 7),
  );
  if (differenceInWeeks < 4) {
    return `${differenceInWeeks} weeks`;
  }

  const differenceInMonths = Math.ceil(
    differenceInTime / (1000 * 3600 * 24 * 30),
  );
  return `${differenceInMonths} months`;
};
